module.exports = require("bs58check");